import React from "react";

const Footer = (props) => {
  return (
    <div className="footer">
      <div className="footer-content">
        <a
          className="footer-content-button"
          onClick={() => {
            props.onCenter();
          }}
        >
          Centerize
        </a>
        <a className="footer-content-button" onClick={props.onReset}>
          Reset
        </a>
      </div>
    </div>
  );
};

export default Footer;
